import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { attentionQueryRoot } from '../../../../shared/api/index.js';
import { paymentQueries } from '../queries/payment-queries.js';
import { markPaymentSeen } from '../requests/mark-payment-seen.js';

export const useMarkPaymentSeenMutation = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markPaymentSeen,
    onSuccess: async (_nothing, id) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: paymentQueries.lists() }),
        queryClient.invalidateQueries({ queryKey: paymentQueries.detail(id).queryKey }),
        queryClient.invalidateQueries({ queryKey: attentionQueryRoot.all(), refetchType: 'all' }),
      ]);
    },
  });
};
